import { NavLink, Outlet } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { SUPPORT_TABS } from './supportTabs'

/** Shell aligned with placements (navy header + pill nav). */
export function SupportLayoutPage() {
  return (
    <div className="space-y-5">
      <div className="overflow-hidden rounded-xl border border-border bg-fintree-navy shadow-sm">
        <div className="px-4 py-3">
          <p className="text-[11px] font-semibold uppercase tracking-wide text-white/70">Support</p>
          <p className="mt-0.5 text-sm font-medium text-white">Community links management.</p>
        </div>
        <nav className="flex flex-wrap gap-1.5 border-t border-border/10 bg-card/95 px-3 py-2.5">
          {SUPPORT_TABS.map((item) => (
            <NavLink
              key={item.id}
              to={item.to}
              className={({ isActive }) =>
                cn(
                  'rounded-full px-3 py-1.5 text-xs font-medium transition-colors',
                  isActive
                    ? 'bg-fintree-navy text-white shadow-sm'
                    : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                )
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  )
}
